import { ACHIEVEMENTS, knownAchievements } from '../models/achievements';
import { Bubble } from './Bubble';

interface Props {
  achievementIds: readonly string[];
  emptyText: string;
}

/** The earned achievements in display order with an "E / 12" count. Locked ones are not listed. */
export function AchievementsSection({ achievementIds, emptyText }: Props) {
  const earned = knownAchievements(achievementIds);
  return (
    <Bubble testId="achievements-section">
      <section aria-label="Achievements">
        <div className="achievements-head">
          <h2 className="t-title-l">Achievements</h2>
          <span className="t-title-m" data-testid="achievements-count">{earned.length} / {ACHIEVEMENTS.length}</span>
        </div>
        {earned.length === 0 ? (
          <p className="achievements-empty">{emptyText}</p>
        ) : (
          <ul className="achievement-list">
            {earned.map((a) => (
              <li key={a.id} className="achievement-row" data-testid={`achievement-${a.id}`}>
                <span className="achievement-emoji" aria-hidden="true">{a.emoji}</span>
                <span className="achievement-text">
                  <span className="t-title-m">{a.name}</span>
                  <span className="achievement-desc">{a.description}</span>
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>
    </Bubble>
  );
}
